import { atom } from 'recoil';

export const isNewWorkerModalOpenAtom = atom<boolean>({
  key: 'isNewWorkerModalOpenState',
  default: false,
});
